import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEventPackages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/event-packages', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEventPackage(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`appointment/event-packages/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEventPackage(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/event-packages/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
